import React from 'react';

import { FooterUnorderedList } from './FooterUnorderedList';
import { SocialMediaList } from './SocialMediaList';

import { CASHCLEVER } from '../../constants';

import {
  companyFooterList,
  linksAndSupportFooterList,
  legalFooterList,
  SOCIAL_MEDIA,
  CashCleverCopyRight,
} from '../../constants/Footer';

import CashClever from '../Cashclever.png';

import './Footer.css';

export const Footer = ({ currentPath }) => {
  return (
    <div className="footer-wrapper">
      <div className="footer-content-wrapper">
        <div className="footer-cashclever-header-wrapper">
          <h3 className="cash-clever-header">
            {' '}
            <img
              src={CashClever}
              height="30"
              width="30"
              id="cashcleverImg"
              alt="CashCleverLogo"
            />{' '}
            {CASHCLEVER}{' '}
          </h3>
        </div>
        <div className="company-links-support-wrapper">
          <div>
            <FooterUnorderedList
              title={companyFooterList.title}
              list={companyFooterList.list}
              currentPath={currentPath}
            />
            {/* <li>Testimony</li> */}
            {/* Let's add testimonies when we have more to show */}
          </div>
          <div className="links-support-wrapper-in-company-link-wrapper">
            <FooterUnorderedList
              title={linksAndSupportFooterList.title}
              list={linksAndSupportFooterList.list}
              currentPath={currentPath}
            />
          </div>
        </div>

        <div className="links-support-wrapper">
          <FooterUnorderedList
            title={linksAndSupportFooterList.title}
            list={linksAndSupportFooterList.list}
            currentPath={currentPath}
          />
        </div>
        <div className="legal-social-media-wrapper">
          <div>
            <FooterUnorderedList
              title={legalFooterList.title}
              list={legalFooterList.list}
              currentPath={currentPath}
            />
          </div>
          <div className="social-media-wrapper-in-legal-media-wrapper">
            <SocialMediaList title={SOCIAL_MEDIA} />
          </div>
        </div>

        <div className="social-media-wrapper">
          <SocialMediaList title={SOCIAL_MEDIA} />
        </div>
      </div>
      <div className="cashclever-copyright">{CashCleverCopyRight}</div>
    </div>
  );
};
